/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { getVersionWhitelist } from '@/reducers/elasticStack'
import { addWhitelistedVersion, removeWhitelistedVersion } from '@/actions/elasticStack'

import WhitelistSwitch from './WhitelistSwitch'

import type { ReduxState } from '@/types/redux'
import type { StateProps, ConsumerProps, DispatchProps } from './WhitelistSwitch'

const mapStateToProps = (state: ReduxState, { region }: ConsumerProps): StateProps => ({
  whitelist: getVersionWhitelist(state, region.id),
})

const mapDispatchToProps: DispatchProps = {
  addWhitelistedVersion,
  removeWhitelistedVersion,
}

export default connect(mapStateToProps, mapDispatchToProps)(WhitelistSwitch)
